<template>
    <div>
        
        <!-- 뷰 -->
        <post-view v-if="id" :id="id"/>
        <div class="loading-spinner" v-if="!postlists.data">
            <base-spinner></base-spinner>
        </div>
        
        <!-- 항목 테이블 -->        
        <div class="tbl_wrap" v-if="postlists.data">
            <table class="tbl">
                <colgroup>
                <col style="width:15%" />
                <col style="width:53%" />
                <col style="width:19%" />
                <col style="width:7%" />
                <col style="width:7%" />
                <col style="width:6%" />
                </colgroup>
                <thead>
                <tr>
                    <th>분류</th>
                    <th class="txt-left">제목</th>
                    <th>작성자</th>
                    <th>등록일</th>
                    <th>조회</th>
                    <th>추천</th>
                </tr>
                </thead>
                <tbody>
                <template v-if="postlists.data.length ===0">
                    <tr><td colspan="6">작성한 게시글이 없습니다.</td></tr>
                    
                </template>
                    <template v-else>
                        <tr v-for="(list, index) in postlists.data" :key="index">
                        <td>{{list.document.title}}</td>
                        <td class="article_title txt-left">
                        <post-title :document="list.document.name" :list="list" :searchview="true"/>
                        </td>
                        <td class="article_writer">{{list.user.nic}}</td>
                        <td>
                            <display-time :time="list.created_at"/>
                        </td>
                        <td>{{list.count}}</td>
                        <td>{{list.recommend}}</td>
                    </tr>   
                    </template>

                </tbody>
            </table>
            
            <paginate store="posts" collection="postsdata"  @paging="fetchLists"/>
        </div>
        <!-- 항목 테이블 -->
    </div>
</template>
<script>
import { postSearch } from '@/components/mixins/pages/postSearch.js'
export default { 
    name:'post_search',  
    mixins:[postSearch]
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/table';
</style>
